import { useRef, useState } from "react";
import { toast } from "sonner";
import { UploadCloud, Loader2 } from "lucide-react";
import client from "@/lib/api";

export default function Uploader({ accept = "image/*", onUploaded, label = "Upload", testid }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await client.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      const absolute = `${process.env.REACT_APP_BACKEND_URL}${data.url}`;
      onUploaded(absolute);
      toast.success("Uploaded");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <>
      <input ref={ref} type="file" accept={accept} className="hidden" onChange={handle} data-testid={testid} />
      <button
        type="button"
        onClick={() => ref.current?.click()}
        disabled={busy}
        className="inline-flex items-center gap-2 rounded-lg border border-white/15 bg-ink-900 px-3 py-2 font-mono2 text-[10px] uppercase tracking-widest text-white/70 transition-colors hover:border-gold hover:text-gold-light disabled:opacity-60"
      >
        {busy ? <Loader2 size={13} className="animate-spin" /> : <UploadCloud size={13} />} {busy ? "Uploading…" : label}
      </button>
    </>
  );
}
